import React from 'react';
import RFModelChart from './analysis/RFModelChart';
import ForecastChart from './analysis/ForecastChart';
import DecompositionChart from './analysis/DecompositionChart';

const AnalysisTab = ({ rfData, forecastData, housingDecompData, unempDecompData }) => {
  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-xl font-bold text-gray-900 mb-4">Predictive Analysis</h2>
        <RFModelChart data={rfData} />
      </div>

      <div>
        <h2 className="text-xl font-bold text-gray-900 mb-4">Future Projections</h2>
        <ForecastChart data={forecastData} />
      </div>

      <div>
        <h2 className="text-xl font-bold text-gray-900 mb-4">Time Series Decomposition</h2>
        <DecompositionChart 
          housingData={housingDecompData}
          unemploymentData={unempDecompData}
        />
      </div>

      <div>
        <h2 className="text-xl font-bold text-gray-900 mb-4">SWOT Analysis</h2>
        <div className="bg-white rounded-lg shadow-md border border-gray-100 p-6">
          <div className="flex flex-col items-center">
            <img
              src="/SWOT-Analysis.png"
              alt="SWOT Analysis Diagram"
              className="max-w-full h-auto rounded-lg"
            />
            <p className="text-sm text-gray-600 italic">
              This SWOT analysis evaluates our project's internal capabilities and external factors.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalysisTab;